/**
 * API module
 * Notification API module.
 */
import { ApiModule } from '@/api/api-module'
import routes from './routes'

export class ApiNotification extends ApiModule {
  /**
   * Получение списка уведомлений
   * @param type - тип (all или system)
   * @returns {Promise<any>}
   */
  list(data) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.list, data).then(
        response => {
          resolve(response.data.list)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  /**
   * Удаление уведомления
   * @param id - идентификатор уведомления
   * @returns {Promise<any>}
   */
  delete(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(routes.delete+'/'+id).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  /**
   * Отметить уведомление прочитанным
   * @param id - идентификатор уведомления
   * @returns {Promise<any>}
   */
  update(id) {
    return new Promise((resolve, reject) => {
      this.http.patch(routes.update+'/'+id).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  /**
   * Отметить все прочитанными
   * @param type
   * @returns {Promise<any>}
   */
  viewedAll(){
    return new Promise((resolve, reject) => {
      this.http.post(routes.viewedAll).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  /**
   * Получение статуса уведомления
   * @param url
   * @returns {Promise<any>}
   */
  status(url){
    return new Promise((resolve, reject) => {
      this.http.get(url).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  /**
   * Принятие/Отклонение приглашения на пост
   * @param id - Идентификатор приглашения
   * @param accept - Статус - true / false
   * @returns {Promise<any>}
   */
  acceptInvite(id, accept){
    return new Promise((resolve, reject) => {
      this.http.post(routes.acceptInvite, { invite_id:id, accept: accept }).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  /**
   * Принятие/Отклонение предложения на владение статистикой
   * @param id - Идентификатор предложения
   * @param accept - Статус - true / false
   * @returns {Promise<any>}
   */
  acceptStatistic(id, accept){
    return new Promise((resolve, reject) => {
      this.http.post(routes.acceptStatistic, { invite_id:id, accept: accept }).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
}

// Create and export module class instance.
let apiNotification = new ApiNotification("notification")
export { apiNotification }



// WEBPACK FOOTER //
// ./src/apps/notifications/api/index.js